import { GreenBold } from 'components/Tables/ActivityTableV2/CellEvent/CellEventFormatter'
import { CellEventFormatterProps } from '../../utils'
import { DefaultUpdateEvent } from './DefaultUpdateEvent'

export const DocumentUpdateEvent = ({ event }: CellEventFormatterProps) => {
  // For document association updates, check field_history_objects for the custom field names
  if (event.field_history_objects && event.field_history_objects.length > 0) {
    const firstField = event.field_history_objects[0]

    const associationFieldMap: Record<string, string> = {
      product_association: 'product association',
      variant_association: 'product variant association',
      company_association: 'company association',
    }

    // Check if any field_history_object has an association field
    if (firstField.field_name in associationFieldMap) {
      const fieldName = associationFieldMap[firstField.field_name]
      const value = firstField.value

      return (
        <>
          changed <GreenBold>{fieldName}</GreenBold> to{' '}
          <b>{value || '(blank)'}</b>
        </>
      )
    }
  }

  // For document ID-based updates without field_history_objects, convert field names
  const idFieldMap: Record<string, string> = {
    product_id: 'product association',
    variant_id: 'product variant association',
    contact_company_id: 'company association',
  }

  if (event.field_name in idFieldMap) {
    const fieldName = idFieldMap[event.field_name]
    const value = Array.isArray(event.value) ? event.value[0] : event.value

    return (
      <>
        changed <GreenBold>{fieldName}</GreenBold> to{' '}
        <b>{value || '(blank)'}</b>
      </>
    )
  }

  // For other document updates (name, tags), use default behavior
  return <DefaultUpdateEvent event={event} />
}
